

































import router from "@/router/router";
import { Component, Vue, Prop } from "vue-property-decorator";
import InfoIconComponent from "@/components/common/InfoIcon.vue";

interface SettingItem {
  title: string;
  additionalText?: string;
  /** An explanation behind an (i) beside the title, instead of a second line. */
  info?: string;
  path?: string;
  onClickCallback?: () => void;
  icon?: string;
  allowMultiline?: boolean;
  visible: boolean;
}

export interface SettingData {
  title: string;
  items: SettingItem[];
}

@Component({ components: { "info-icon": InfoIconComponent } })
export default class SettingsItemComponent extends Vue {
  @Prop()
  settingData!: SettingData;

  get items() {
    return this.settingData.items.filter(data => data.visible)
  }

  allowMultiline(settingItem: SettingItem) {
    if (settingItem.allowMultiline) {
      return true;
    }

    return false;
  }

  isClickable(settingItem: SettingItem) {
    return settingItem.path || settingItem.onClickCallback;
  }

  created(){
    this.settingData.items.map(data => data?.visible ? data.visible : true);
  }
  openSettings(settingItem: SettingItem) {
    if (settingItem.onClickCallback) {
      settingItem.onClickCallback();
      return;
    }

    if (!settingItem.path) {
      return;
    }

    router.push({
      path: settingItem.path,
      append: true,
    });
  }
}
